import { Tile, TileStripe } from "@dash/tile";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom-v5-compat";
import tinycolor from "tinycolor2";

import { getMegaraxPath } from "@megaron/megarax-uri";
import { Uuid } from "@megaron/uuid";

type Props = {
  uuid: string;
  name: string;
  className?: string;
};

export const SameGooglePlaceTile: React.FC<Props> = ({ uuid, name, className }) => {
  const theme = useTheme();

  return (
    <Link
      to={getMegaraxPath.uri("megarax://crm/customer/{id}", { id: Uuid(uuid) })}
      css={{
        ":hover": {
          textDecoration: "none",
          h4: {
            textDecoration: "underline",
          },
        },
      }}
      className={className}
    >
      <Tile
        stripe={<TileStripe color={theme.colors.primary}></TileStripe>}
        css={{
          borderRadius: theme.smallBorderRadius,
          border: `1px solid ${tinycolor(theme.colors.primary).setAlpha(0.1)}`,
        }}
      >
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            width: "100%",
          }}
        >
          <span
            css={{
              fontSize: "16px",
              color: theme.colors.primary,
            }}
          >
            {name}
          </span>
        </div>
      </Tile>
    </Link>
  );
};
